var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultationCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22769_8934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 40C44.7733 40 40 44.7733 40 50.6667C40 52.6667 40.56 54.56 41.5467 56.16C43.3867 59.2533 46.7733 61.3333 50.6667 61.3333C54.56 61.3333 57.9467 59.2533 59.7867 56.16C60.7733 54.56 61.3333 52.6667 61.3333 50.6667C61.3333 44.7733 56.56 40 50.6667 40ZM56.1867 49.52L50.5067 54.7733C50.1333 55.12 49.6267 55.3067 49.1467 55.3067C48.64 55.3067 48.1333 55.12 47.7333 54.72L45.0933 52.08C44.32 51.3067 44.32 50.0267 45.0933 49.2533C45.8667 48.48 47.1467 48.48 47.92 49.2533L49.2 50.5333L53.4667 46.5867C54.2667 45.84 55.5467 45.8933 56.2933 46.6933C57.04 47.4933 56.9867 48.7467 56.1867 49.52Z",
    fill: "#98134D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6663 20.1333V21.3333C58.6663 22.8 57.4663 24 55.9997 24H7.99967C6.53301 24 5.33301 22.8 5.33301 21.3333V20.1067C5.33301 14 10.2663 9.06665 16.373 9.06665H47.5997C53.7063 9.06665 58.6663 14.0267 58.6663 20.1333Z",
    fill: "#98134D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 30.6667V43.8933C5.33301 50 10.2663 54.9333 16.373 54.9333H33.0663C34.613 54.9333 35.9463 53.6267 35.813 52.08C35.4397 48 36.7463 43.5733 40.373 40.0533C41.8663 38.5867 43.7063 37.4667 45.7063 36.8267C49.0397 35.76 52.2663 35.8933 55.1197 36.8533C56.853 37.44 58.6663 36.1867 58.6663 34.3467V30.64C58.6663 29.1733 57.4663 27.9733 55.9997 27.9733H7.99967C6.53301 28 5.33301 29.2 5.33301 30.6667ZM21.333 46H15.9997C14.9063 46 13.9997 45.0933 13.9997 44C13.9997 42.9067 14.9063 42 15.9997 42H21.333C22.4263 42 23.333 42.9067 23.333 44C23.333 45.0933 22.4263 46 21.333 46Z",
    fill: "#98134D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22769_8934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationCard);
export default __webpack_public_path__ + "static/media/consultation-card.7252967b87ec23f4f275dc9c012c0538.svg";
export { ForwardRef as ReactComponent };